import { Component, OnInit, OnChanges, Output, EventEmitter, SimpleChanges, Input } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AddressValidationService } from '../../shared/address-validation/address-validation.service';
import { InstitutionsService } from '../../shared/services/institutions.service';
import { Institution } from '../../shared/model/institution';
import { MatDialog } from '@angular/material';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';
import { SaveService } from '../../shared/services/save.service';

@Component({
  selector: 'institution-form',
  templateUrl: './institution-form.component.html',
  styleUrls: ['./institution-form.component.css']
})
export class InstitutionFormComponent implements OnInit, OnChanges {

  isDelete = true;
  institutionValid = true;
  clientValid = true;

  @Output()
  outForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  @Input()
  inInstitution: Institution;

  form: FormGroup;

  constructor(private fb: FormBuilder,
    private institutionsService: InstitutionsService,
    private saveService: SaveService,
    private addressValidationService: AddressValidationService,
    public dialog: MatDialog) {
  }

  ngOnInit() {
    if (!this.inInstitution) {
      this.newForm();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.inInstitution.currentValue) {
      this.updateForm(changes.inInstitution.currentValue);
    }
  }

  newForm() {
    const currentUser = this.saveService.getUser();
    this.form = this.fb.group({
      institutionName: ['', Validators.required],
      institutionAddress: ['', Validators.required],
      institutionCity: ['', Validators.required],
      institutionProv: ['Québec', Validators.required],
      institutionPostalCode: ['', Validators.required],
      institutionCountry: ['Canada', Validators.required],
      institutionPhone: ['', Validators.required],
      institutionPhoneExt: ['', null],
      institutionRespOrgName: ['', Validators.required],
      institutionType: ['', Validators.required],
      institutionAdmRegion: ['', Validators.required],
      institutionEmail: ['', [Validators.required, Validators.email]],
      contactFirstName: [currentUser.firstName, Validators.required],
      contactLastName: [currentUser.lastName, Validators.required],
      contactTitle: ['', Validators.required],
      contactPhone: [currentUser.phoneWork, Validators.required],
      contactPhoneExt: [currentUser.PhoneExt, Validators.required],
      contactEmail: [currentUser.email, [Validators.required, Validators.email]],
      student: [false, null],
      teacher: [false, null],
      guardDuty: [false, null],
      buses: [false, null],
      smsNotification: [false, null],
      emailNotification: [false, null],
      phoneNotification: [false, null],
      powerUserTransfert: [false, null],
      preSchool: [false, null],
      primarySchool: [false, null],
      secondarySchool: [false, null],
      adultSchool: [false, null],
      professionnelSchool: [false, null],
      collegeSchool: [false, null],
      universitySchool: [false, null],
      languageFrench: [false, null],
      languageEnglish: [false, null]
    });
    this.outForm.emit(this.form);
    this.form.valueChanges.subscribe(() => {
      this.outForm.emit(this.form);
    });

  }

  updateForm(institution: Institution) {
    this.form = this.fb.group({
      institutionName: [institution.institutionName, Validators.required],
      institutionAddress: [institution.institutionAddress, Validators.required],
      institutionCity: [institution.institutionCity, Validators.required],
      institutionProv: [institution.institutionProv, Validators.required],
      institutionPostalCode: [institution.institutionPostalCode, Validators.required],
      institutionCountry: [institution.institutionCountry, Validators.required],
      institutionPhone: [institution.institutionPhone, Validators.required],
      institutionPhoneExt: [institution.institutionPhoneExt, null],
      institutionEmail: [institution.contactEmail, [Validators.required, Validators.email]],
      institutionRespOrgName: [institution.institutionRespOrgName, Validators.required],
      institutionType: [institution.institutionType, Validators.required],
      institutionAdmRegion: [institution.institutionAdmRegion, Validators.required],
      contactFirstName: [institution.contactFirstName, Validators.required],
      contactLastName: [institution.contactLastName, Validators.required],
      contactTitle: [institution.contactTitle, Validators.required],
      contactPhone: [institution.contactPhone, Validators.required],
      contactPhoneExt: [institution.contactPhoneExt, Validators.required],
      contactEmail: [institution.contactEmail, [Validators.required, Validators.email]],
      student: [institution.student, null],
      teacher: [institution.teacher, null],
      guardDuty: [institution.guardDuty, null],
      buses: [institution.buses, null],
      smsNotification: [institution.buses, null],
      emailNotification: [institution.buses, null],
      phoneNotification: [institution.buses, null],
      powerUserTransfert: [institution.buses, null],
      preSchool: [institution.preSchool, null],
      primarySchool: [institution.primarySchool, null],
      secondarySchool: [institution.secondarySchool, null],
      adultSchool: [institution.adultSchool, null],
      professionnelSchool: [institution.professionnelSchool, null],
      collegeSchool: [institution.collegeSchool, null],
      universitySchool: [institution.universitySchool, null],
      languageFrench: [false, null],
      languageEnglish: [false, null]
    });
    this.outForm.emit(this.form);
    this.form.valueChanges.subscribe(() => {
      this.outForm.emit(this.form);
    });

  }

  onDelete() {
    this.openDialog();
    if (this.isDelete) {
      console.log("supprimer un institution = ", this.inInstitution.institutionName);
    }
  }

  openDialog(): void {
    let dialogRef = this.dialog.open(ConfirmDialogComponent, {
      height: '200px',
      width: '400px',
      position: {'top':'150px'},
      data: {
        content: `Êtes-vous sur de vouloir supprimer l'institution ${this.inInstitution.institutionName}`,
        title: "Confirmation de suppression",
        twoButton: true
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.isDelete = result;
    });
  }

  initFormTest() {
      this.form.controls.institutionName.setValue("Collège de Test");
      this.form.controls.institutionAddress.setValue("2420 Henri-Bourassa #4");
      this.form.controls.institutionCity.setValue("Montréal");
      this.form.controls.institutionProv.setValue("Québec");
      this.form.controls.institutionPostalCode.setValue("H2B 2D5");
      this.form.controls.institutionCountry.setValue("Canada");
      this.form.controls.institutionPhone.setValue("514-764-3425");
      this.form.controls.institutionPhoneExt.setValue("123");
      this.form.controls.institutionRespOrgName.setValue("Commission Scolaire de Montréal");
      this.form.controls.institutionType.setValue("Privé");
      this.form.controls.institutionAdmRegion.setValue("Montréal");
      this.form.controls.institutionEmail.setValue("collegetest@test.com");
      // this.form.controls.contactFirstName.setValue("Isabelle");
      // this.form.controls.contactLastName.setValue("Caron");
      this.form.controls.contactTitle.setValue("Directrice générale");
      // this.form.controls.contactPhone.setValue("514-887-3421");
      // this.form.controls.contactPhoneExt.setValue("123");
      // this.form.controls.contactEmail.setValue("isabelle@hotmail.com");
      this.form.controls.student.setValue(true);
      this.form.controls.teacher.setValue(false);
      this.form.controls.guardDuty.setValue(true);
      this.form.controls.buses.setValue(false);
      this.form.controls.smsNotification.setValue(true);
      this.form.controls.emailNotification.setValue(false);
      this.form.controls.phoneNotification.setValue(true);
      this.form.controls.powerUserTransfert.setValue(false);
      this.form.controls.preSchool.setValue(true);
      this.form.controls.primarySchool.setValue(false);
      this.form.controls.secondarySchool.setValue(true);
      this.form.controls.adultSchool.setValue(false);
      this.form.controls.professionnelSchool.setValue(true);
      this.form.controls.collegeSchool.setValue(false);
      this.form.controls.universitySchool.setValue(true);
  }

}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/institutions/institution-form/institution-form.component.ts